export default {
    getCookie(name) {
        var items = document.cookie.split(';');
        for (var i = 0; i < items.length; i++) {
            var p = items[i].indexOf('=')
            if (p > -1 && name.toUpperCase() === this.trim(items[i].substring(0, p).toUpperCase())) {
                return items[i].substring(p + 1)
            }
        }
    },
    trim(str) {
        return str && str.replace(/^\s*(.+?)\s*$/, '$1')
    },
    deleteCookie(name, path, domain) {
        if (this.getCookie(name)) {
            document.cookie = name + '=' +
                ((path) ? '; path=' + path : '') +
                ((domain) ? '; domain=' + domain : '') +
                '; expires=Thu, 01-Jan-70 00:00:01 GMT';
        }
    },
    setCookie(name, value, path, domain, secure) {
        const expires = new Date()
        expires.setTime(expires.getTime() + 30 * 24 * 3600 * 1000);
        this.deleteCookie(name, '/');
        document.cookie = name + '=' + escape(value) +
            ((expires) ? '; expires=' + expires.toGMTString() : '') +
            ((path) ? '; path=' + path : '') +
            ((domain) ? '; domain=' + domain : '') +
            ((secure) ? '; secure' : '');
    },
    setLongCookie(name, value, path, domain, secure) {
        document.cookie = name + '=' + escape(value) +
            '; expires=Mon, 31 Jan 3200 16:00:00 UTC' +
            ((path) ? '; path=' + path : '') +
            ((domain) ? '; domain=' + domain : '') +
            ((secure) ? '; secure' : '');
    },
}
